// extracted by mini-css-extract-plugin
export var label = "_48-1";
export var reminder = "_48-0";